export default __webpack_public_path__ + "37ba570.png";